export const ProjectEarlierModel = [
    {
        name: "Web Portfolio",
        hotlink: "https://github.com/pro10150/pro10150.github.io",
        description: "A web portfolio to showcase my life. From my education to work experiences. This project using React to create and will static website to reduce cost for hosting the website to the bare minimum.",
        skill: [
            "React",
            "CSS"
        ]
    }, {
        name: "Little Lemon",
        hotlink: "https://github.com/pro10150/littlelemon",
        description: "An iOS app created as an example to showcase my skills I've learned from Coursera's Meta iOS Developer Professional Certificate. This project is pure SwiftUI and only for education purpose only.",
        skill: [
            "SwiftUI"
        ]
    }, {
        name: "Muvi",
        hotlink: "https://github.com/pro10150/muvi-backend",
        description: "A final project for my Bachelor's degree. I was the project manager and responsible for all the back-end development, save for Machine Learning model and implementation.",
        skill: [
            "Python",
            "FastAPI",
            "SQL",
            "Project Management"
        ]
    }, {
        name: "Parking System",
        hotlink: "https://github.com/pro10150/parking-system",
        description: "An IoT project for automatic parking system. This prototype is created to taggle the problem with wasted paper usage for slip. You can check all your information about parking, fee and parking time included, right on your phone. I've built most of the front-end using React except for CSS and created the entire backend. I've tackled with C++ and Arduino for this project.",
        skill: [
            "Python",
            "React",
            "Flask",
            "SQL"
        ]
    }, {
        name: "Hew'a",
        hotlink: "https://github.com/pro10150/hew-a",
        description: "A Software Engineering Project. Built under a simple every-day question: What should I eat today? Offers a platform to post a recipe and looking for a recipe with machine learning that will provide you with the recipe that most suited you. I was the Project Manager and was responsible for building most of the application. For front-end, It was built with Flutter.",
        skill: [
            "Flutter",
            "Project Management"
        ]
    }, {
        name: "Hew'a - API",
        hotlink: "https://github.com/pro10150/hewa-api",
        description: "A Software Engineering Project. Built under a simple every-day question: What should I eat today? Offers a platform to post a recipe and looking for a recipe with machine learning that will provide you with the recipe that most suited you. I was responsible for building most of the application. For back-end, It was built with Flask API. ",
        skill: [
            "FlaskAPI",
            "SQL"
        ]
    }
]
